(() => {
  const initBijonGallery = () => {
    const section = document.querySelector('#product-section-3');
    if (!section || section.dataset.bijonGalleryReady === 'true') return;

    section.dataset.bijonGalleryReady = 'true';

    const desktopItems = Array.from(
      section.querySelectorAll('.product-gallery-desktop .gallery-image-container')
    );
    const thumbnailButtons = Array.from(
      section.querySelectorAll('.bijon-product-thumbnail')
    );

    desktopItems.forEach((item, index) => {
      item.dataset.galleryIndex = String(index);
      item.id = `bijon-product-media-${index}`;
    });

    const setActiveThumbnail = (index) => {
      thumbnailButtons.forEach((button, buttonIndex) => {
        const active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    thumbnailButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.dataset.galleryIndex);
        const target = desktopItems[index];
        if (!target) return;

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setActiveThumbnail(index);
      });
    });

    if ('IntersectionObserver' in window && desktopItems.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!visible) return;
          setActiveThumbnail(Number(visible.target.dataset.galleryIndex));
        },
        {
          root: null,
          rootMargin: '-20% 0px -55% 0px',
          threshold: [0.15, 0.35, 0.6]
        }
      );

      desktopItems.forEach((item) => observer.observe(item));
    }

    const mobileGallery = section.querySelector('.product-gallery-mobile');
    const mobileSlides = Array.from(section.querySelectorAll('.gallery-slide'));

    if (mobileGallery && mobileSlides.length > 1) {
      mobileGallery.setAttribute('aria-label', 'Swipe through product images');
      mobileGallery.style.scrollSnapType = 'x mandatory';

      mobileSlides.forEach((slide) => {
        slide.style.scrollSnapAlign = 'start';
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBijonGallery);
  } else {
    initBijonGallery();
  }

  document.addEventListener('shopify:section:load', initBijonGallery);
})();

/* FIX 3: enhance the active related-products cards without depending on
   a specific section filename. */
(() => {
  const processed = new WeakSet();

  const getHandle = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (error) {
      return null;
    }
  };

  const addSecondaryImage = async (item) => {
    if (!item || processed.has(item)) return;
    processed.add(item);

    const link = item.querySelector('a[href*="/products/"]');
    const wrapper = item.querySelector('.related-product-row__image-wrapper');
    const primary = item.querySelector('.related-product-row__image');
    if (!link || !wrapper || !primary) return;

    primary.classList.add('related-product-row__image--primary');

    if (wrapper.querySelector('.related-product-row__image--secondary')) {
      item.classList.add('has-bijon-secondary');
      return;
    }

    const handle = getHandle(link.href);
    if (!handle) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin'
      });
      if (!response.ok) return;

      const product = await response.json();
      if (!product.images || product.images.length < 2) return;

      const secondary = document.createElement('img');
      secondary.className = 'related-product-row__image related-product-row__image--secondary';
      secondary.src = product.images[1];
      secondary.alt = product.title || primary.alt || '';
      secondary.loading = 'lazy';
      wrapper.appendChild(secondary);
      item.classList.add('has-bijon-secondary');
    } catch (error) {
      /* The first image and hover overlay still work if the fetch fails. */
    }
  };

  const enhanceRelatedProducts = (root = document) => {
    root.querySelectorAll('.related-product-row__item').forEach(addSecondaryImage);
  };

  const init = () => {
    enhanceRelatedProducts();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.related-product-row__item')) addSecondaryImage(node);
          enhanceRelatedProducts(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => enhanceRelatedProducts());
})();